module.exports = __webpack_public_path__ + "static/media/MC.a6ed56ab.svg";